/** A Viewpoint AP vendor (APVM) as the Tool Tracker API's vendor search returns it (camelCase). */
export interface VpVendorName {
  vendor: number;
  name: string;
  vendorGroup: number;
}
